import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.5065 3.75C7.46486 3.75 5.83333 7.41667 2.625 12C5.83333 16.5833 7.46486 20.25 12.5065 20.25C17.5482 20.25 19.1798 16.5833 22.3882 12C19.1798 7.41667 17.5482 3.75 12.5065 3.75Z",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1),
    _createElementVNode("path", {
      d: "M15.2578 12C15.2578 13.5188 14.0266 14.75 12.5078 14.75C10.989 14.75 9.75781 13.5188 9.75781 12C9.75781 10.4812 10.989 9.25 12.5078 9.25C14.0266 9.25 15.2578 10.4812 15.2578 12Z",
      stroke: "#454342",
      "stroke-width": "1.5"
    }, null, -1)
  ])))
}
export default { render: render }